import isEmpty from 'lodash/isEmpty'
import { useState, useEffect } from 'react'
import api, { IBuildingDetails, IPortfolioCity, IPortfolioRegion } from '@api'
import { useShouldReload } from '@hooks/reloadContext'

let persistedState: IPortfolioRegion[] = []

export default function useLocations(
  includeOldBuildings?: boolean,
  skipEmptyBuildings?: boolean
): IPortfolioRegion[] {
  const [regions, setRegions] = useState<IPortfolioRegion[]>(persistedState)
  const shouldRelaod = useShouldReload()

  useEffect(() => {
    api.portfolio
      .regions({
        showInactiveBuildings: !!includeOldBuildings,
      })
      .then(
        ({
          data: {
            viewer: {
              company: { portfolioRegions },
            },
          },
        }) =>
          setRegions(
            skipEmptyBuildings ? getLocationWithoutEmptyItems(portfolioRegions) : portfolioRegions
          )
      )
  }, [includeOldBuildings, skipEmptyBuildings, shouldRelaod.buildings])

  useEffect(() => {
    persistedState = regions
  })

  return regions
}

const getBuildings = (city: IPortfolioCity) => {
  return city.buildings.reduce<IBuildingDetails[]>((buildingsAcc, building) => {
    return isEmpty(building.floors) ? buildingsAcc : [...buildingsAcc, building]
  }, [])
}

const getCities = (region: IPortfolioRegion) => {
  return region.cities.reduce<IPortfolioCity[]>((citiesAcc, city) => {
    const buildings = getBuildings(city)
    return isEmpty(buildings) ? citiesAcc : [...citiesAcc, { ...city, buildings }]
  }, [])
}

const getLocationWithoutEmptyItems = (regions: IPortfolioRegion[]): IPortfolioRegion[] =>
  regions.reduce<IPortfolioRegion[]>((regionsAcc, region) => {
    const cities = getCities(region)

    return isEmpty(cities) ? regionsAcc : [...regionsAcc, { ...region, cities }]
  }, [])
